import {
    BUILDING_CONSTRUCT_REACTIVE,
    BUILDING_UPGRADE_REACTIVE,
} from 'channels/clan/actions'

import { STRONGHOLD_LOAD_SUCCESS } from '../actions/stronghold'
import { BUILDING_CONSTRUCTION_SUCCESS } from '../actions/building_construction'
import { SLOT_INFO_REQUEST, SLOT_INFO_ERROR, SLOT_INFO_SUCCESS } from '../actions/slots'

const initialState = {}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case STRONGHOLD_LOAD_SUCCESS: {
        const { slots } = action.payload
        return {
            ...slots,
        }
    }
    case BUILDING_CONSTRUCTION_SUCCESS: {
        const { slotId, building } = action.payload
        return {
            ...state,
            [slotId]: {
                ...state[slotId],
                building: building.id,
            },
        }
    }
    case SLOT_INFO_REQUEST: {
        const { slotId } = action.payload
        return {
            ...state,
            [slotId]: {
                ...state[slotId],
                loading: true,
                errorMessage: '',
            },
        }
    }
    case SLOT_INFO_SUCCESS: {
        const { slot } = action.payload
        return {
            ...state,
            [slot.id]: { ...state[slot.id], ...slot, loading: false },
        }
    }
    case SLOT_INFO_ERROR: {
        const { slotId, errorMessage } = action.payload
        return {
            ...state,
            [slotId]: {
                ...state[slotId],
                errorMessage,
                loading: false,
            },
        }
    }
    case BUILDING_CONSTRUCT_REACTIVE:
    case BUILDING_UPGRADE_REACTIVE: {
        const { slotId, building } = action.payload
        const slotState = state[slotId] || {}
        return {
            ...state,
            [slotId]: {
                ...slotState,
                building: building.id,
            },
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/slots.js